// Some colors appear more than once to provide useful alternate aliases
const colors = {
  blue: "rgb(70,80,223)",
  green: "#28a639",
  black: "#50514f",
  grey: "#7e807d",
  white: "#ffffff",
  lightGrey: "#d4dad1",
  almostWhite: "rgba(200,200,200,0.5)",
  offWhite: "#FEFBFA",
  body: "#50514F",
} as const;

export default colors;
